<header class="hdr" [class.hdr--portal]="mode() === 'portal'">
  <a class="brand" [routerLink]="homePath()" [attr.aria-label]="tenant.name() + ', home'">
    @if (tenant.logoUrl()) {
      <img class="mark" [src]="tenant.logoUrl()" alt="" />
    } @else {
      <span class="mark mark--letter" aria-hidden="true">{{ tenant.initial() }}</span>
    }
    <span class="brand-text">
      <span class="brand-name">{{ tenant.name() }}</span>
      @if (mode() !== 'portal') {
        <span class="brand-sub">
          Client onboarding@if (tenant.isWhiteLabel()) { · powered by Bizcombo }
        </span>
      }
    </span>
  </a>

  @if (mode() === 'portal') {
    <nav class="main-nav" aria-label="Main">
      @for (item of nav(); track item.label) {
        <a [routerLink]="item.path" [attr.aria-current]="isCurrent(item) ? 'page' : null">{{ item.label }}</a>
      }
    </nav>
  }

  <div class="end">
    @switch (mode()) {
      @case ('plain') {
        <!-- Welcome page: one secondary way back in; the page itself leads with Create an account. -->
        @if (!isSignedIn()) {
          <button type="button" class="bc-btn bc-btn--compact" (click)="signIn()">Sign in</button>
        }
      }
      @case ('signup') {
        @if (isSignedIn()) {
          <span class="muted email">{{ userEmail }}</span>
          <button type="button" class="link-btn" (click)="logout()">Sign out</button>
        } @else if (showSignIn()) {
          <span class="muted">Already have an account?</span>
          <button type="button" class="link-btn" (click)="signIn()">Sign in</button>
        }
      }
      @case ('portal') {
        <app-notification-bell></app-notification-bell>

        <button type="button" class="user" [matMenuTriggerFor]="userMenu" aria-haspopup="menu">
          <span class="avatar" aria-hidden="true">{{ userInitials }}</span>
          <span class="user-text">
            <span class="user-name">{{ userName }}</span>
            @if (companyName) { <span class="user-org">{{ companyName }}</span> }
          </span>
          <mat-icon class="chev" aria-hidden="true">expand_more</mat-icon>
        </button>

        <mat-menu #userMenu="matMenu" xPosition="before">
          <div class="menu-head">
            <span class="menu-name">{{ userName }}</span>
            <span class="menu-email">{{ userEmail }}</span>
          </div>
          <mat-divider />
          <button mat-menu-item (click)="goToSettings()">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </button>
          <mat-divider />
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      }
    }
  </div>
</header>
